import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { scorePropTypes } from './ScorePropTypes';
import Star from '@Theme/natucare/components/Star/Star';
import * as styles from './Score.module.scss';
const Score = ({
  i18n = {
    heading: 'Oceń artykuł',
    message: 'Głos oddany',
    votes: 'opinii,',
    score: 'ocena'
  },
  votes,
  score,
  hasVoted = false,
  onStarClick
}) => {
  const formattedScore = score.toFixed(1);
  const fullStars = Math.floor(score);
  const halfStars = Math.round(score - fullStars);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, i18n.heading && /*#__PURE__*/React.createElement("span", {
    className: styles.rootHeading
  }, i18n.heading), /*#__PURE__*/React.createElement("div", {
    className: styles.rootScore
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootScoreValue
  }, formattedScore), /*#__PURE__*/React.createElement("div", {
    className: styles.rootScoreStars
  }, _toConsumableArray(Array(5)).map((_, index) => {
    const value = 5 - index;
    const filled = value <= fullStars;
    const half = value === fullStars + 1 && halfStars > 0;
    return /*#__PURE__*/React.createElement(Star, {
      "data-value": value,
      filled: filled,
      half: half,
      key: value,
      onClick: onStarClick
    });
  })), /*#__PURE__*/React.createElement("span", {
    className: `${styles.rootScoreMsg} ${hasVoted ? styles.rootScoreMsgShow : ''}`
  }, i18n.message)), /*#__PURE__*/React.createElement("div", {
    className: styles.rootVotes
  }, votes, " ", i18n.votes, " ", i18n.score, ": ", formattedScore));
};
export default Score;